import React from 'react'
import Header from '../components/Header'
import IndividualProduct from '../components/individualProduct';
import ProductsBanner from "../components/ProductsBanner";
import WhatsAppFloatingButton from "../components/WhatsAppFloatingButton";
import Footer from '../components/Footer';
import { Helmet } from "react-helmet";

const BloodPressure = () => {
  const title = "Dr. Chek D - Accurate Blood Pressure Monitoring";
  const description =
    "The Dr. Chek D Digital Blood Pressure Monitor ensures accurate and reliable BP measurements. Perfect for home use, featuring easy-to-read displays and comfortable cuff designs.";
  
    const productData = {
    name: "Dr. Chek BP",
    image: "/images/Dr Chek BP_270x270.webp",
    "description":"The Dr. Chek BP Blood Pressure Meter empowers you to monitor your heart health from home. This reliable blood pressure meter delivers accurate blood pressure readings and heart rate monitoring. Ideal for home blood pressure monitoring, it's user-friendly for all ages. Track your hypertension or hypotension with ease. Featuring a clear display, this digital blood pressure monitor provides quick results. Explore best blood pressure monitor options with Dr. Chek. Manage your cardiovascular health effectively and make informed decisions with accurate BP readings. Ensure regular blood pressure check for a healthier lifestyle.",
    features: [
      "	One touch automatic measurement.",
      "Intelligent pressurized; Double filter fuzzy algorithm to calculate suitable pressure, ensure best comport feeling and increase accuracy.",
      "Dual settings, allows two users to store up to 99 blood pressure readings with data and time for record comparison.",
      "IHB (Irregular Heartbeat) detection function.",
      "Average value display of three times measurement.",
      "Power Saving Design: Auto power off the unit in 3minutes idling."
    ],
    "brochure": {
      "pages": [
        "/images/Dr-Chek-BP-Blood-Pressure-Monitor-brochure-page-1.jpg",
        "/images/Dr-Chek-BP-Blood-Pressure-Monitor-brochure-page-2.jpg",
        
      ],
      "url": "/Dr-Chek-BP-Blood-Pressure-Monitor-brochure.pdf"
    }
  };

  

return (
<div>
<Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta
          name="keywords"
          content="Blood pressure meter, Blood pressure monitor, Home blood pressure monitor, Digital blood pressure monitor, Wrist blood pressure monitor, Upper arm blood pressure monitor, BP Meter, Best BP monitor for home use, Accurate blood pressure measurement, Automatic BP monitor, FDA-approved blood pressure monitor, Smart BP monitor with app, Portable blood pressure meter, Wireless blood pressure monitor, Rechargeable BP monitor, Buy blood pressure monitor online, Dr. Chek D BP monitor reviews, Easy-to-use blood pressure checker, Digital sphygmomanometer, Affordable blood pressure monitor"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://drchek.com/" />
      </Helmet>
    <Header/>
    <ProductsBanner
    title="Dr. Chek BP"
    backgroundImage="/images/dr-chek-banner-001.png"
    backgrond="cover"
    height="400px"
  />
  
     <IndividualProduct product={productData} />
   
     
     <Footer/>
    <WhatsAppFloatingButton/>
</div>
)
}

export default BloodPressure;